export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20overhead%20arrangement%20of%20premium%20fashion%20items%20including%20sneakers%20designer%20bag%20leather%20belt%20and%20watch%20on%20dark%20charcoal%20textured%20surface%2C%20editorial%20photography%20with%20dramatic%20warm%20spotlight%2C%20luxury%20aesthetic%2C%20rich%20contrast%20tones%2C%20sophisticated%20composition%20with%20deep%20shadows&width=1800&height=1000&seq=cta-pandabuy-v2-029&orientation=landscape"
        alt="Explore pandabuy spreadsheet collection now"
        title="pandabuy spreadsheet collection CTA"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-6xl text-white leading-tight mb-4 tracking-wide uppercase">
          Start Exploring<br />Pandabuyspreadsheet Now
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-10 max-w-lg mx-auto leading-relaxed">
          Unlock the most comprehensive collection of curated pandabuy spreadsheets. Updated weekly, trusted by thousands.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-white text-base font-semibold hover:bg-foreground-900 transition-all whitespace-nowrap cursor-pointer group"
        >
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 -ml-2">
            <i className="ri-shopping-bag-line text-white text-lg"></i>
          </span>
          BUY IT NOW
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}